import { useEffect } from 'react';
import { useAlloyLaunchDarklyMetaData } from './AlloyLaunchDarklyProvider';
import { useCurrentAccountId } from './CurrentAccountIdContext';
import { useCurrentProjectId } from './CurrentProjectIdContext';
import { useUser } from './ProjectEntitlementsContext';
const AlloyLaunchDarklySubscriber = () => {
  const projectId = useCurrentProjectId();
  const accountId = useCurrentAccountId();
  const {
    user
  } = useUser();
  const {
    setUser,
    setProjectId,
    setAccountId
  } = useAlloyLaunchDarklyMetaData();
  useEffect(() => {
    setUser(user);
  }, [user, setUser]);
  useEffect(() => {
    setProjectId(projectId);
  }, [projectId, setProjectId]);
  useEffect(() => {
    setAccountId(accountId);
  }, [accountId, setAccountId]);
  return null;
};
export default AlloyLaunchDarklySubscriber;
//# sourceMappingURL=AlloyLaunchDarklySubscriber.js.map